import React, { useContext } from 'react';

import { RicosViewerContext } from './../../ricos-context';
import type { NodeViewRenderer, NodeViewRendererProps } from './../../ricos-types';

import { ViewerFigure } from '../../_shared/figure/viewer-figure';
import { VIDEO_ROOT } from '../data-hooks';
import styles from '../statics/styles/video-viewer-scss';
import { VIDEO_TYPE } from '../types';
import { Video } from './video';

const ViewerVideo = ({
  node,
  nodeIndex,
  NodeViewContainer,
  RicosNodesRenderer,
}: NodeViewRendererProps) => {
  const { seoMode, config } = useContext(RicosViewerContext);
  const { videoData } = node;

  if (!videoData) {
    return null;
  }

  return (
    <ViewerFigure
      node={node}
      nodeIndex={nodeIndex}
      NodeViewContainer={NodeViewContainer}
      RicosNodesRenderer={RicosNodesRenderer}
    >
      <div className={styles.video_container} data-hook={VIDEO_ROOT}>
        <Video
          config={config[VIDEO_TYPE] || {}}
          componentData={videoData}
          nodeId={node.id}
          seoMode={!!seoMode}
          isLight
        />
      </div>
    </ViewerFigure>
  );
};

const VideoRenderer: NodeViewRenderer = ({ node, ...props }) => {
  return <ViewerVideo key={node.id} node={node} {...props} />;
};

export default VideoRenderer;
